<mat-card class= "card">
  <header>
    <h3>Registration</h3>
  </header>
  <form 
  style="padding-top: 5%;" 
  [formGroup]="registrationForm" 
  (ngSubmit)="confirm()">
  <div class= "inputForm">
      <input placeholder="Email" formControlName='email'>
      <select placeholder="Role" formControlName='role'>
        <option value="researcher">Researcher</option>
        <option value="admin">Administrator</option>
        <option value="lab_asistant">Lab Asistant</option>
      </select>
  </div>
  <div class= "buttons">
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <button class="button" *ngIf="!loading" [disabled]='!registrationForm.valid || loading' routerLinkActive="router-link-active"> Confirm</button>
  </div>
  </form>
  <div class= "buttons">
  
    <div class="loginSeparator">
      <p>Email will be sent to you to complete the registration</p>
    </div>
    <button class="button secondary" (click)="resendLink()"> Resend Link</button>
  </div>
</mat-card>